import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 50px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12);
`;
